// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorMessage_error__YD3lf","error__message":"ErrorMessage_error__message__2-SAQ"};